module.exports = __webpack_public_path__ + "static/media/wind_power_middle_east_tablet.e2e4079f.jpg";